<template>
  <ul class="pagination">
    <li class="pagination__item pagination__item--first" :class="currentPage - 1 <= 0 ? 'disabled' : ''">
      <a
        @click="$emit('updated',  1)"
        :disabled="currentPage - 1 <= 0"
        title="Primeira (1)"
        tabindex="-1"
        class="pagination__link"
      >
        &laquo;
      </a>
    </li>

    <li class="pagination__item pagination__item--prev" :class="currentPage - 1 <= 0 ? 'disabled' : ''">
      <a
        @click="$emit('updated', currentPage - 1)"
        :disabled="currentPage - 1 <= 0"
        :title="`Anterior (${currentPage - 1})`"
        tabindex="-1"
        class="pagination__link"
      >
        &lsaquo;
      </a>
    </li>

    <li v-if="currentPage - 3 > 0" class="pagination__item">
      <a @click="$emit('updated', currentPage - 3);" class="pagination__link">
        {{currentPage - 3}}
      </a>
    </li>

    <li v-if="currentPage - 2 > 0" class="pagination__item">
      <a @click="$emit('updated', currentPage - 2);" class="pagination__link">
        {{currentPage - 2}}
      </a>
    </li>

    <li v-if="currentPage - 1 > 0"  class="pagination__item">
      <a @click="$emit('updated', currentPage - 1);" class="pagination__link">
        {{currentPage - 1}}
      </a>
    </li>

    <li class="pagination__item active">
      <a @click="$emit('updated', currentPage);" class="pagination__link">
        {{currentPage}}
      </a>
    </li>

    <li v-if="currentPage + 1 <= totalPages" class="pagination__item">
      <a @click="$emit('updated', currentPage +1);" class="pagination__link">
        {{currentPage +1}}
      </a>
    </li>

    <li v-if="currentPage + 2 <= totalPages" class="pagination__item">
      <a @click="$emit('updated', currentPage + 2);" class="pagination__link">
        {{currentPage + 2}}
      </a>
    </li>

    <li v-if="currentPage + 3 <= totalPages" class="pagination__item">
      <a @click="$emit('updated', currentPage + 3);" class="pagination__link">
        {{currentPage + 3}}
      </a>
    </li>

    <li class="pagination__item pagination__item--next" :class="currentPage + 1 > totalPages ? 'disabled' : ''">
      <a
        @click="$emit('updated', currentPage + 1)"
        :disabled="currentPage + 1 > totalPages"
        :title="`Próxima (${currentPage + 1})`"
        class="pagination__link"
      >
        &rsaquo;
      </a>
    </li>

    <li class="pagination__item pagination__item--last" :class="currentPage + 1 > totalPages ? 'disabled' : ''">
      <a
        @click="$emit('updated', totalPages)"
        :disabled="currentPage + 1 > totalPages"
        :title="`Última (${totalPages})`"
        class="pagination__link"
      >
        &raquo;
      </a>
    </li>
  </ul>
</template>

<script>
export default {
  props: {
    totalPages: {
      type: Number,
      required: true
    },
    currentPage: {
      type: Number,
      required: true
    }
  }
}
</script>
